import {
  Plus,
} from "lucide-react";

const EmploymentHeader = ({
  onAdd,
  onNewContract,
}) => {
  return (
    <div className="mb-6 flex items-start justify-between">
      {/* HEADER CONTENT */}

      <div>
        <h1 className="text-2xl font-semibold text-slate-900">
          Employment & Contracts
        </h1>

        <p className="mt-1 text-sm text-slate-500">
          Manage employee employment information,
          classifications, contracts, schedules, and
          employment history.
        </p>
      </div>

      {/* HEADER ACTIONS */}

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onNewContract}
          className="
            flex
            h-10
            items-center
            gap-2
            rounded-lg
            bg-[#147db5]
            px-4
            text-sm
            font-medium
            text-white
            transition
            hover:bg-[#116d9d]
          "
        >
          <Plus
            size={17}
            strokeWidth={2}
          />
          <span>New Contract</span>
        </button>
      </div>
    </div>
  );
};

export default EmploymentHeader;